import { EditCalendar } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { useGetSeasonsQuery } from 'common/api/endpoints/harvestData';
import { handleError } from 'common/api/utils/handleError';
import { FC, useEffect, useMemo } from 'react';
import { SeasonSelectModal } from './SeasonSelectModal';
import { EditSeasonsBtn, SeasonBubble, SeasonFilterWrapper } from './styles';

export const SeasonToSyncFilter: FC<{
  disabled: boolean;
  setShowModal: (show: boolean) => void;
  showModal: boolean;
}> = ({ disabled, setShowModal, showModal }) => {
  const { data: seasons, isLoading, error } = useGetSeasonsQuery();

  const sortedSeasons = useMemo(
    () =>
      seasons && seasons.length > 0
        ? [...seasons].sort((a, b) => b.year - a.year)
        : [],
    [seasons],
  );

  const seasonsToSync = useMemo(
    () => seasons?.filter(season => season.isActive),
    [seasons],
  );

  useEffect(() => {
    if (error) {
      handleError(error, 'There was an issue fetching seasons.');
    }
  }, [error]);

  return (
    <SeasonFilterWrapper>
      <span>Seasons to sync:</span>
      {isLoading && <CircularProgress size='25px' />}
      {seasonsToSync?.length &&
        !isLoading &&
        seasonsToSync?.map(season => (
          <SeasonBubble key={season.year}>
            <span>{season.year}</span>
          </SeasonBubble>
        ))}
      <EditSeasonsBtn
        type='button'
        onClick={() => setShowModal(true)}
        disabled={disabled}
      >
        <EditCalendar />
      </EditSeasonsBtn>
      {showModal && (
        <SeasonSelectModal
          closeModal={() => setShowModal(false)}
          seasons={sortedSeasons}
        />
      )}
    </SeasonFilterWrapper>
  );
};
